var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dmpUrls.length)?_c('div',_vm._l((_vm.dmpUrls),function(item){return _c('img',{key:item.name,staticStyle:{"display":"none !important"},attrs:{"src":item.url,"alt":"DMP tracking code"}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }